module.exports = __webpack_public_path__ + "static/media/mastercard.7e82cd30.svg";